import MarkdownIt from 'markdown-it'

// Initialize markdown-it with desired options
const md = new MarkdownIt({
  html: true, // Enable HTML tags in source
  linkify: true, // Autoconvert URL-like text to links
  typographer: true, // Enable some language-neutral replacement + quotes beautification
  breaks: true // Convert '\n' in paragraphs into <br>
})

// Configure links to open in a new window
const defaultRender =
  md.renderer.rules.link_open ||
  function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options)
  }

md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  // Add target="_blank" and rel="noopener noreferrer" to external links
  tokens[idx].attrPush(['target', '_blank'])
  tokens[idx].attrPush(['rel', 'noopener noreferrer'])

  // Pass token to default renderer.
  return defaultRender(tokens, idx, options, env, self)
}

// Store UTM parameters globally within this module for the plugin
let currentUtmParams = null

// Plugin to add UTM parameters to links
function utmLinkPlugin(mdInstance) {
  const originalLinkOpen =
    mdInstance.renderer.rules.link_open ||
    function (tokens, idx, options, env, self) {
      return self.renderToken(tokens, idx, options)
    }

  mdInstance.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    if (currentUtmParams) {
      const hrefIndex = tokens[idx].attrIndex('href')
      if (hrefIndex >= 0) {
        try {
          const originalUrl = tokens[idx].attrs[hrefIndex][1]
          // Ensure the URL is absolute or resolve it based on a base URL if needed
          // For simplicity, assuming absolute URLs or URLs relative to the current page
          const url = new URL(originalUrl, window.location.origin)
          const utmParams = new URLSearchParams(currentUtmParams)

          utmParams.forEach((value, key) => {
            if (key.startsWith('utm_')) {
              url.searchParams.set(key, value)
            }
          })
          tokens[idx].attrs[hrefIndex][1] = url.toString()
        } catch (e) {
          console.error('Error processing URL for UTM params:', e)
          // Keep original URL if parsing fails
        }
      }
    }
    // Call the original renderer or the previously wrapped one (like target=_blank)
    return originalLinkOpen(tokens, idx, options, env, self)
  }
}

// Apply the UTM plugin
md.use(utmLinkPlugin)

// Function to set UTM parameters and return the configured markdown-it instance
export const configureConverter = (urlParams) => {
  if (urlParams) {
    currentUtmParams = new URLSearchParams(urlParams).toString()
  } else {
    currentUtmParams = null
  }
  // Return the configured instance
  return md
}

// Export a function to render markdown, ensuring configuration is applied
export const renderMarkdown = (markdownString, utmParamsString) => {
  const converter = configureConverter(utmParamsString)
  return converter.render(markdownString || '')
}

// Keep the stripMarkdown function as it is library-independent
export const stripMarkdown = (markdown) => {
  if (markdown === undefined) return ''
  // Basic stripping, might need adjustments depending on markdown-it output nuances
  return markdown
    .replace(/[_*~`>#-]/g, '') // Remove common Markdown symbols
    .replace(/\[([^\]]+)]\((.*?)\)/g, '$1') // Remove links but keep text
    .replace(/!\[.*?\]\(.*?\)/g, '') // Remove images
    .replace(/<[^>]*>/g, '') // Strip HTML tags potentially generated
    .replace(/\n+/g, ' ') // Replace newlines with spaces
    .trim()
}

// Example of how you might use it elsewhere:
// import { renderMarkdown } from './converter';
// const utm = 'utm_source=test&utm_medium=banner';
// const html = renderMarkdown('This is a [link](https://example.com).', utm);
